module.exports = __webpack_public_path__ + "e0d3c6a7b81325301cfa3cc7c132260c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/14_C#3.mp3
// module id = 113
// module chunks = 0